/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import BulkUpload from 'components/common/BulkUpload';
import React from 'react';
import { Button, Card, CardBody, Label, TabContent, TabPane } from 'reactstrap';
import { RingIcon } from 'components/common/RingIcon';
import Select from 'react-select';
import DebounceTextInput from 'components/DebounseTextInput';
import Heading from 'components/Heading';
import { FSBTable } from 'components/common/FSBTable';
import CustomTabs from 'components/CustomTabs';
import { BsCloudUpload, BsDownload, BsPlus } from 'react-icons/bs';
import { IoSettingsOutline } from 'react-icons/io5';
import FSBModal from 'components/common/FSBModal';
import CreateRate from './components/CreateRate';
import AdvanceControls from './components/AdvanceControls';
import { useRateCardManagement } from './useRateCardManagement';
import RateCardDetails from './components/RateCardDetails';
import { DELIVERY_RATES_TABS_HEADING } from './constants';
import { DELIVERY_RATE_REQUEST_TABLE_COLUMNS } from './constant';

const RateCardManagement = () => {
  const {
    isCreateRateOpen,
    activeTab,
    cellSelectedFromPin,
    cellSelectedToPin,
    downloadExcel,
    editData,
    fromOptions,
    handleCellClick,
    handleChangeStatus,
    handleCreateRate,
    handleEditRate,
    isRateDetailsOpen,
    loading,
    matrixColumn,
    matrixData,
    searchString,
    selectedFromValue,
    selectedToValue,
    setIsCreateRateOpen,
    setSearchString,
    setSelectedFromValue,
    setSelectedToValue,
    toOptions,
    setEditData,
    toggle,
    defaultValue,
    handleCloseDetails,
    refetchRateData,
    fetchAdvanceControlSettings,
    advanceControlSetting,
    bulkUploadLoading,
    bulkUploadOpen,
    setBulkUploadOpen,
    advanceControlsOpen,
    setAdvanceControlsOpen,
    handleBulkUpload,
    requestedDeliveryRateLoading,
    requestedDeliveryRate,
  } = useRateCardManagement();

  return (
    <div className>
      <FSBModal
        open={isCreateRateOpen}
        size="lg"
        title={`${editData ? 'Update' : 'Create'} Rate Card`}
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        toggleAlert={() => {
          setIsCreateRateOpen(false);
          setEditData(undefined);
        }}
        onClose={() => {
          setIsCreateRateOpen(false);
          setEditData(undefined);
        }}
        // onConfirmClick={drawerToggle}
        modalClass="create-rate-modal"
      >
        <CreateRate
          onDiscard={() => {
            setIsCreateRateOpen(false);
            setEditData(undefined);
          }}
          defaultValues={editData}
          onCreateRate={handleCreateRate}
          disablePinInputs={editData}
        />
      </FSBModal>

      <FSBModal
        open={isRateDetailsOpen}
        size="lg"
        title="Rate Card Details"
        closeButtonLabel=""
        confirmButtonLabel=""
        message=""
        toggleAlert={handleCloseDetails}
        onClose={handleCloseDetails}
        modalClass="rate-card-details-modal"
      >
        <RateCardDetails
          fromPin={cellSelectedFromPin}
          toPin={cellSelectedToPin}
          onChangeStatus={handleChangeStatus}
          onCreateRate={handleCreateRate}
          onEditRate={handleEditRate}
          refetchRateData={refetchRateData}
        />
      </FSBModal>

      <div className="mb-3 pb-1 top-head">
        <Heading
          title="Rate Card Management"
          description="View and manage delivery rates between different PIN codes. Use the matrix below to check or update shipping costs for specific routes with ease."
        />
      </div>
      <Card className="border-0 card-box">
        <CardBody>
          <div className="d-flex">
            <CustomTabs
              tabs={[
                DELIVERY_RATES_TABS_HEADING.INDIAN,
                DELIVERY_RATES_TABS_HEADING.FOREIGN,
              ]}
              selectedTab={activeTab}
              onTabChange={toggle}
              className="mb-2"
              disabledTabs={[DELIVERY_RATES_TABS_HEADING.FOREIGN]}
            />
            <div className="d-flex gap-3">
              <Button
                color="primary"
                type="button"
                className="text-nowrap rounded-2 p-1 pe-3 d-flex align-items-center gap-2"
                size="sm"
                onClick={() => {
                  setIsCreateRateOpen(true);
                }}
              >
                <BsPlus size={24} />
                Create Rate Card
              </Button>
              <Button
                color="primary"
                type="button"
                className="text-nowrap rounded-2 p-1 ps-2 pe-3 d-flex align-items-center gap-2"
                size="sm"
                onClick={() => {
                  setBulkUploadOpen(true);
                }}
              >
                <BsCloudUpload size={16} />
                Upload Bulk Rate
              </Button>
              <Button
                type="button"
                className="text-nowrap rounded-2 p-1 ps-2 pe-3 d-flex align-items-center gap-2"
                size="sm"
                onClick={() => {
                  setAdvanceControlsOpen(true);
                }}
              >
                <IoSettingsOutline size={16} />
                Advance Controls
              </Button>
            </div>
          </div>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={DELIVERY_RATES_TABS_HEADING.INDIAN}>
              {activeTab === DELIVERY_RATES_TABS_HEADING.INDIAN && (
                <div>
                  <div className="d-flex justify-content-between">
                    <div className="filter-row-ui">
                      <div className="form-group">
                        <Label>From PIN</Label>
                        <Select
                          name="Select From PIN"
                          options={fromOptions}
                          getOptionLabel={(option) => option?.entityName}
                          getOptionValue={(option) => option?.id}
                          placeholder="Select From PIN"
                          classNamePrefix="react-select"
                          value={selectedFromValue}
                          defaultValue={defaultValue}
                          // defaultMenuIsOpen
                          onChange={(value) => setSelectedFromValue(value)}
                        />
                      </div>
                      <div className="form-group">
                        <Label>To PIN</Label>
                        <Select
                          name="Select To PIN"
                          options={toOptions}
                          getOptionLabel={(option) => option?.entityName}
                          getOptionValue={(option) => option?.id}
                          placeholder="Select To PIN"
                          classNamePrefix="react-select"
                          value={selectedToValue}
                          defaultValue={defaultValue}
                          // defaultMenuIsOpen
                          onChange={(value) => setSelectedToValue(value)}
                        />
                      </div>
                    </div>
                    <div>
                      <DebounceTextInput
                        onInputChange={(value) => setSearchString(value)}
                        delay={500} // Set your desired delay in milliseconds
                        value={searchString}
                        positionRight="65px"
                        positionTop="2px"
                      />
                      <Button
                        className="rounded-5 p-0"
                        style={{
                          height: 34,
                          width: 34,
                        }}
                        onClick={downloadExcel}
                      >
                        <BsDownload size={16} />
                      </Button>
                    </div>
                  </div>
                  {/* <Row>
                    <Col className="text-end" sm={3}>
                      <DebounceTextInput
                        onInputChange={(value) => setSearchString(value)}
                        delay={500} // Set your desired delay in milliseconds
                        value={searchString}
                        classWrapper="right-search"
                        placeholder="Search"
                        positionTop="-30px"
                        positionRight="20px"
                      />
                    </Col>
                  </Row> */}
                  <FSBTable
                    columns={matrixColumn}
                    data={matrixData}
                    showPagination={false}
                    isMatrixTable
                    loading={loading}
                    onCellClick={(cell) => {
                      handleCellClick(cell);
                    }}
                  />

                  {/* we have to use this component inside the rate card management page */}
                  <FSBModal
                    open={advanceControlsOpen}
                    size="lg"
                    title="Advance Controls"
                    closeButtonLabel=""
                    confirmButtonLabel=""
                    message=""
                    toggleAlert={() => setAdvanceControlsOpen(false)}
                    onClose={() => setAdvanceControlsOpen(false)}
                    modalClass="advance-control-modal"
                  >
                    <AdvanceControls
                      afterSubmitFetch={fetchAdvanceControlSettings}
                      markupPercentage={
                        advanceControlSetting?.values &&
                        advanceControlSetting?.values[1]?.value
                      }
                      appSettingId={advanceControlSetting?.id}
                      isRateVisible={
                        advanceControlSetting?.values &&
                        advanceControlSetting?.values[0]?.value
                      }
                      onDiscard={() => setAdvanceControlsOpen(false)}
                    />
                  </FSBModal>

                  <FSBModal
                    open={bulkUploadOpen}
                    size="lg"
                    title="Upload Bulk Rate"
                    closeButtonLabel=""
                    confirmButtonLabel=""
                    message=""
                    toggleAlert={() => {
                      setBulkUploadOpen(false);
                    }}
                    onClose={() => {
                      setBulkUploadOpen(false);
                    }}
                    onConfirmClick={() => {}}
                    modalClass="bulk-upload-modal"
                  >
                    <BulkUpload
                      onDiscard={() => setBulkUploadOpen(false)}
                      onUpload={handleBulkUpload}
                      loading={bulkUploadLoading}
                      submitButtonText="Update Rate"
                      templateText={
                        <span>
                          Please use the provided template format <br /> for
                          accurate upload.
                        </span>
                      }
                      supportedFormatText={
                        <>
                          <span>Supported Format</span>{' '}
                          <span style={{ fontWeight: 600, color: '#6C757D' }}>
                            .xlsx (Excel)
                          </span>
                        </>
                      }
                      descriptionText="Upload an Excel sheet to add or update multiple delivery rates at once. Ensure the file follows the provided template to avoid errors."
                    />
                  </FSBModal>
                </div>
              )}
            </TabPane>
            <TabPane tabId={DELIVERY_RATES_TABS_HEADING.FOREIGN}>
              {activeTab === DELIVERY_RATES_TABS_HEADING.FOREIGN && (
                <span>Coming soon!</span>
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
      <div className="delivery-rate-request-table-card">
        <Card className="border-0 card-box">
          <CardBody>
            <div className="title-container">
              <span className="title">Delivery Rate Requests</span>
              <span className="new-request">
                <RingIcon borderColor="#FD7E14" bgColor="#FD7E14" />
                <span className="new-request-text">New Request</span>
              </span>
            </div>
            <FSBTable
              data={requestedDeliveryRate}
              totalCount={0}
              totalPages={0}
              columns={DELIVERY_RATE_REQUEST_TABLE_COLUMNS}
              keyField="id"
              showSearch={false}
              showFilters={false}
              showDelete={false}
              showPagination={false}
              remote
              striped={false}
              hover={false}
              bordered={false}
              wrapperClass="table-responsive word-break"
              onSortChange={() => {}}
              searchPlaceholder="Search Vendors"
              loading={requestedDeliveryRateLoading}
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default RateCardManagement;
